




























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';

import * as GROUP_STATS_QUERY from 'src/graphql/admin/GroupStats.graphql';

@Component({
  apollo: {
    group_stats: {
      query: GROUP_STATS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class GroupStats extends Vue {

  get groups() {
    return this.$store.state.groups;
  }

  group_stats = [];

  headers = [
    { text: 'Group',                          value: 'group',               class: 'fixed-column' },
    { text: 'Projects (total)',               value: 'projects',            align: 'center' },
    { text: 'Projects (active last 30 days)', value: 'projects_30',         align: 'center' },
    { text: 'Projects (archived)',            value: 'projects',            align: 'center' },
    { text: 'Simulations (total)',            value: 'simulations',         align: 'center' },
    { text: 'Simulations (last 30 days)',     value: 'simulations_30_days', align: 'center' },
    { text: 'Simulations (last hour)',        value: 'simulations_1_hour',  align: 'center' },
  ];
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/GroupStats.vue